import { apiGet, apiSend } from './client';
import type { ApiKeyResponse } from './types';

export async function fetchApiKeyStatus() {
  return apiGet<ApiKeyResponse>('/me/api-key');
}

export async function generateApiKey() {
  return apiSend<ApiKeyResponse>('/me/api-key', 'POST');
}

export async function revokeApiKey() {
  return apiSend<ApiKeyResponse>('/me/api-key', 'DELETE');
}
